export default __webpack_public_path__ + "static/media/grid-icon.4f75599c.svg";